export enum FilterCondition {
  EQUALS = 'eq',
  NOT_EQUALS = 'ne',
  GREATER_THAN = 'gt',
  GREATER_THAN_OR_EQUAL = 'ge',
  LESS_THAN_OR_EQUAL = 'le',
  LESS_THAN = 'lt',
  CONTAINS = 'contains',
  NOT_CONTAINS = 'notContains',
  ENDS_WITH = 'endsWith',
  STARTS_WITH = 'startsWith',
  INCLUDES_ANY = 'includesAny',
  EXCLUDES_ANY = 'excludesAny',
  INCLUDES_ALL = 'includesAll',
  EXCLUDES_ALL = 'excludesAll',
  IS_EMPTY = 'isEmpty',
  IS_NOT_EMPTY = 'isNotEmpty',
  EXISTS = 'exists',
}

export interface LabeledFilterCondition {
  value: FilterCondition
  label: string
}
